import _ from 'lodash';


export function buildQueryStr(query, currentPage) {
  query.currentPage = currentPage;
  const q2 = _.map(query, (v, k) => {
    console.log(v,k);
    if (k === 'category' && Array.isArray(v)) {
      console.log('v', v);
      return v.map(cat => `category=${cat}`).join('&');
    }
    return `${k}=${v}`;
  }).join('&');
  const q3 = `/s?${q2}`;
  return q3;
}



// WEBPACK FOOTER //
// ./src/routes/search/Search.logic.js